class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const formData = JSON.parse(serializeForm(this.form));

    // Convert flat `properties[Key]` fields into a nested `properties` object
    const properties = {};
    Object.keys(formData).forEach((key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) {
        properties[match[1]] = formData[key];
        delete formData[key];
      }
    });
    if (Object.keys(properties).length > 0) {
      formData.properties = properties;
    }

    const body = JSON.stringify({
      ...formData,
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    console.log(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
